// extracted by mini-css-extract-plugin
export default {"modal-container":"dialog_modal-container__1g8xL","modal-buttons":"dialog_modal-buttons__M+B4K","title":"dialog_title__pev8B","close-icon":"dialog_close-icon__aS5OK"};